import AuthHelper from 'helpers/auth_helper'
import Settings from 'helpers/settings'

const handleErrors = (response) => {
  if (!response.ok) {
    throw Error(response.statusText)
  }
  return response
}

export const getFinalURL = (url, params = {}) => {
  let finalUrl = url
  if (!url.startsWith('http')) {
    finalUrl = Settings.SWIPECAST_BACKEND + url
  }

  const query = new URLSearchParams(params).toString()
  if (query === '') return finalUrl
  return `${finalUrl}?${query}`
}

/** @deprecated v1 - seems like it does not handle errors. for new endpoints use v2 instead */
export const requestV1 = (url, method = 'GET', body = null) => {
  const finalURL = getFinalURL(url)

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${AuthHelper.currentAuthToken()}`,
    credentials: 'include',
  }

  return (
    fetch(finalURL, { method, body, headers })
      .then(handleErrors)
      .then((res) => res.json())
      // eslint-disable-next-line
      .catch((error) => console.log(error))
  )
}

export const requestV2 = async (
  url,
  { method = 'GET', body = null, params = {}, pureResponse = false, formData = null }
) => {
  const finalURL = getFinalURL(url, params)

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${AuthHelper.currentAuthToken()}`,
    credentials: 'include',
  }

  if (formData) delete headers['Content-Type']

  const buildBody = () => {
    if (formData) return formData
    if (body) return JSON.stringify(body)
    return null
  }

  const response = await fetch(finalURL, { method, headers, body: buildBody() })
  if (pureResponse) return await response.json()

  if (!response.ok) {
    let errorMessage
    try {
      const json = await response.json()
      const { error, message, errors } = json
      errorMessage = error || message || (errors ? Object.entries(errors)[0].join(' ') : null)
    } catch {
      errorMessage = response.statusText
    }
    const error = new Error(errorMessage)
    error.status = response.status
    throw error
  }

  return response.json()
}
